import React from 'react';
import { useSelector } from 'react-redux';

import { useLocation, Navigate } from 'react-router-dom';
import { selectIsAuthenticated, selectAuthLoading } from '../redux/authSlice';


export default function PrivateRoute({ children }) {
  const isAuthenticated = useSelector(selectIsAuthenticated);
  const loading = useSelector(selectAuthLoading);
  const location = useLocation();

  console.log('PrivateRoute: loading=', loading, 'isAuthenticated=', isAuthenticated, 'path=', location.pathname);

  if (loading){
    console.log("Still loading, returning null");
    return null;
  } 

  if (!isAuthenticated) {

    return <Navigate to="/login" replace />;
  }

  return children;
}